/**
 * @generated SignedSource<<27a1f894f6e1b7a7081693847343deae>>
 * @relayHash 0934429a266ff3e583c5fb4342982735
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4dccebc1b350e29c4d965ab8e7f8f78d325669b985e4e4f15a4c5f2c3d1e646a

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type ProjectPanelQuery$variables = {
  ari: string;
  capabilitiesContainerId: string;
  cloudId: string;
  isProjectNativeIntegrationEnabled: boolean;
  queryContext?: string | null;
};
export type ProjectPanelQuery$data = {
  readonly goals_capabilities: {
    readonly canCreateGoal: boolean | null;
  } | null;
  readonly me: {
    readonly user: {
      readonly accountId: string;
      readonly id: string;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null;
  };
  readonly projects_byId: Result<{
    readonly canEditMembers: boolean | null;
    readonly contributors: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly userContributor: {
            readonly id: string;
          } | null;
        } | null;
      } | null> | null;
    } | null;
    readonly id: string;
    readonly owner: {
      readonly id: string;
    } | null;
    readonly url: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectActionsContent" | "ProjectContributesTo" | "ProjectContributors" | "ProjectCustomFields" | "ProjectFocusAreas" | "ProjectFollowers" | "ProjectJiraWork" | "ProjectLinks" | "ProjectOwner" | "ProjectPanelHeader" | "ProjectPanelTabs" | "ProjectStartDate" | "ProjectStatusField" | "ProjectTags" | "ProjectTargetDate" | "ProjectWorkTracked" | "RelatedProjects">;
  } | null, unknown>;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectActionsContent_Capabilities" | "ProjectFocusAreas_MercuryWorkspace">;
};
export type ProjectPanelQuery = {
  response: ProjectPanelQuery$data;
  variables: ProjectPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ari"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "capabilitiesContainerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isProjectNativeIntegrationEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryContext"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "picture"
},
v8 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v9 = [
  {
    "kind": "Variable",
    "name": "projectId",
    "variableName": "ari"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "url"
},
v11 = [
  (v5/*: any*/)
],
v12 = {
  "kind": "ScalarField",
  "name": "canEditMembers"
},
v13 = {
  "kind": "Variable",
  "name": "queryContext",
  "variableName": "queryContext"
},
v14 = [
  (v13/*: any*/)
],
v15 = [
  {
    "kind": "Variable",
    "name": "containerId",
    "variableName": "capabilitiesContainerId"
  }
],
v16 = {
  "args": (v15/*: any*/),
  "concreteType": "TownsquareGoalAppCapabilities",
  "kind": "LinkedField",
  "name": "goals_capabilities",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "canCreateGoal"
    }
  ]
},
v17 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v18 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v19 = [
  (v18/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/)
],
v20 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isUser"
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "AtlassianAccountUserExtendedProfile",
      "kind": "LinkedField",
      "name": "extendedProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jobTitle"
        }
      ]
    }
  ],
  "type": "AtlassianAccountUser"
},
v22 = {
  "kind": "ScalarField",
  "name": "count"
},
v23 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v24 = {
  "kind": "ScalarField",
  "name": "canEditMetadata"
},
v25 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v26 = {
  "kind": "ScalarField",
  "name": "dark"
},
v27 = {
  "kind": "ScalarField",
  "name": "light"
},
v28 = {
  "kind": "ScalarField",
  "name": "description"
},
v29 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v30 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v31 = {
  "kind": "ScalarField",
  "name": "key"
},
v32 = {
  "kind": "ScalarField",
  "name": "value"
},
v33 = [
  (v32/*: any*/)
],
v34 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "start"
    },
    {
      "kind": "ScalarField",
      "name": "end"
    }
  ]
},
v35 = {
  "kind": "ScalarField",
  "name": "summary"
},
v36 = [
  {
    "concreteType": "TownsquareLinkEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TownsquareLink",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v10/*: any*/),
          (v6/*: any*/)
        ]
      }
    ]
  },
  (v23/*: any*/)
],
v37 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v38 = [
  (v31/*: any*/),
  (v5/*: any*/)
],
v39 = {
  "kind": "InlineFragment",
  "selections": (v11/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v40 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v41 = {
  "kind": "InlineFragment",
  "selections": (v11/*: any*/),
  "type": "AppUser"
},
v42 = {
  "kind": "InlineFragment",
  "selections": (v11/*: any*/),
  "type": "CustomerUser"
},
v43 = [
  {
    "concreteType": "TownsquareHighlightEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v18/*: any*/),
          (v5/*: any*/)
        ]
      }
    ]
  }
],
v44 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v45 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v18/*: any*/),
                (v6/*: any*/),
                (v5/*: any*/),
                (v8/*: any*/),
                (v7/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v44/*: any*/),
            (v40/*: any*/)
          ]
        }
      ]
    },
    (v23/*: any*/)
  ]
},
v46 = [
  {
    "kind": "ScalarField",
    "name": "label"
  },
  (v34/*: any*/)
],
v47 = [
  {
    "alias": "projectValue",
    "kind": "ScalarField",
    "name": "value"
  }
],
v48 = [
  (v18/*: any*/),
  (v7/*: any*/),
  (v6/*: any*/),
  (v8/*: any*/),
  (v5/*: any*/)
],
v49 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v48/*: any*/)
},
v50 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v48/*: any*/)
},
v51 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v52 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v35/*: any*/),
      (v28/*: any*/),
      (v49/*: any*/),
      (v50/*: any*/),
      (v40/*: any*/),
      (v51/*: any*/)
    ],
    "type": "TownsquareHighlight",
    "abstractKey": "__isTownsquareHighlight"
  }
],
v53 = [
  (v5/*: any*/),
  (v6/*: any*/),
  (v28/*: any*/)
],
v54 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v55 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v56 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v30/*: any*/),
    (v29/*: any*/)
  ]
},
v57 = {
  "kind": "ScalarField",
  "name": "canRemoveLinkedWorkItems"
},
v58 = {
  "kind": "ScalarField",
  "name": "canAddLinkedWorkItems"
},
v59 = {
  "kind": "ScalarField",
  "name": "webUrl"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "CatchField",
        "field": {
          "args": (v9/*: any*/),
          "concreteType": "TownsquareProject",
          "kind": "LinkedField",
          "name": "projects_byId",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            (v10/*: any*/),
            {
              "kind": "LinkedField",
              "name": "owner",
              "plural": false,
              "selections": (v11/*: any*/)
            },
            {
              "concreteType": "TownsquareContributorConnection",
              "kind": "LinkedField",
              "name": "contributors",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareContributorEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "concreteType": "TownsquareContributor",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "userContributor",
                          "plural": false,
                          "selections": (v11/*: any*/)
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            (v12/*: any*/),
            {
              "condition": "isProjectNativeIntegrationEnabled",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "args": (v14/*: any*/),
                  "kind": "FragmentSpread",
                  "name": "ProjectJiraWork"
                }
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectPanelHeader"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectTags"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectTargetDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectStatusField"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectOwner"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectLinks"
            },
            {
              "condition": "isProjectNativeIntegrationEnabled",
              "kind": "Condition",
              "passingValue": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "ProjectWorkTracked"
                }
              ]
            },
            {
              "args": (v14/*: any*/),
              "kind": "FragmentSpread",
              "name": "ProjectFocusAreas"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectStartDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "RelatedProjects"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectContributesTo"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectContributors"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectFollowers"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectActionsContent"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectPanelTabs"
            },
            {
              "kind": "FragmentSpread",
              "name": "ProjectCustomFields"
            }
          ]
        },
        "to": "RESULT"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "capabilitiesContainerId",
            "variableName": "capabilitiesContainerId"
          }
        ],
        "kind": "FragmentSpread",
        "name": "ProjectActionsContent_Capabilities"
      },
      (v16/*: any*/),
      {
        "args": (v17/*: any*/),
        "kind": "FragmentSpread",
        "name": "ProjectFocusAreas_MercuryWorkspace"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v9/*: any*/),
        "concreteType": "TownsquareProject",
        "kind": "LinkedField",
        "name": "projects_byId",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v10/*: any*/),
          {
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": (v19/*: any*/)
          },
          {
            "concreteType": "TownsquareContributorConnection",
            "kind": "LinkedField",
            "name": "contributors",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareContributorEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareContributor",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "userContributor",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          (v5/*: any*/),
                          (v8/*: any*/),
                          (v20/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v21/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareTeamContributor",
                        "kind": "LinkedField",
                        "name": "teamContributor",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "contributingMembers",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v18/*: any*/),
                                      (v8/*: any*/),
                                      (v5/*: any*/),
                                      (v20/*: any*/),
                                      (v6/*: any*/),
                                      (v7/*: any*/),
                                      (v21/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v22/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TeamV2",
                            "kind": "LinkedField",
                            "name": "team",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "displayName"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "smallAvatarImageUrl"
                              },
                              {
                                "concreteType": "TeamMemberConnectionV2",
                                "kind": "LinkedField",
                                "name": "members",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TeamMemberEdgeV2",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "TeamMemberV2",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "member",
                                            "plural": false,
                                            "selections": (v19/*: any*/)
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "profileUrl"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "state"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "permission"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "isVerified"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v23/*: any*/)
            ]
          },
          (v12/*: any*/),
          (v6/*: any*/),
          {
            "concreteType": "TownsquareProjectCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canAddTags"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveTags"
              },
              {
                "kind": "ScalarField",
                "name": "canEditTargetDate"
              },
              {
                "kind": "ScalarField",
                "name": "canEditStatus"
              },
              {
                "kind": "ScalarField",
                "name": "canManageOwnership"
              },
              {
                "kind": "ScalarField",
                "name": "canAddRelatedLink"
              },
              {
                "kind": "ScalarField",
                "name": "canEditRelatedLink"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveRelatedLink"
              },
              {
                "kind": "ScalarField",
                "name": "canAddLinkedFocusAreas"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedFocusAreas"
              },
              {
                "concreteType": "TownsquareProjectAppCapabilities",
                "kind": "LinkedField",
                "name": "apps",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareFocusAppCapabilities",
                    "kind": "LinkedField",
                    "name": "focus",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "canViewFocusAreas"
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canEditStartDate"
              },
              {
                "kind": "ScalarField",
                "name": "canAddContributors"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveContributors"
              },
              {
                "kind": "ScalarField",
                "name": "canAddWatchers"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveWatchers"
              },
              {
                "kind": "ScalarField",
                "name": "canManageAccess"
              },
              {
                "kind": "ScalarField",
                "name": "canArchiveProject"
              },
              (v25/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canCommentOnProject"
              },
              {
                "kind": "ScalarField",
                "name": "canCommentOnUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canEditUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canDeleteUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canEditCustomFields"
              }
            ]
          },
          {
            "concreteType": "TownsquareWorkspace",
            "kind": "LinkedField",
            "name": "workspace",
            "plural": false,
            "selections": (v11/*: any*/)
          },
          {
            "concreteType": "TownsquareIconURIs",
            "kind": "LinkedField",
            "name": "iconUrl",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareThemeURIs",
                "kind": "LinkedField",
                "name": "roundedSquare",
                "plural": false,
                "selections": [
                  (v26/*: any*/),
                  (v27/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareTagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareTagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareTag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v10/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "usageCount"
                      },
                      (v28/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v29/*: any*/),
                  (v30/*: any*/)
                ]
              },
              (v23/*: any*/)
            ]
          },
          (v31/*: any*/),
          {
            "kind": "ScalarField",
            "name": "isArchived"
          },
          {
            "concreteType": "TownsquareProjectState",
            "kind": "LinkedField",
            "name": "state",
            "plural": false,
            "selections": (v33/*: any*/)
          },
          {
            "concreteType": "TownsquareTargetDate",
            "kind": "LinkedField",
            "name": "dueDate",
            "plural": false,
            "selections": [
              (v34/*: any*/),
              {
                "kind": "ScalarField",
                "name": "confidence"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "startDate"
          },
          {
            "concreteType": "TownsquareProjectUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              (v23/*: any*/)
            ]
          },
          {
            "kind": "ScalarField",
            "name": "watcherCount"
          },
          {
            "concreteType": "TownsquareProjectUpdate",
            "kind": "LinkedField",
            "name": "latestUserUpdate",
            "plural": false,
            "selections": [
              (v35/*: any*/),
              {
                "concreteType": "TownsquareUpdateNoteConnection",
                "kind": "LinkedField",
                "name": "updateNotes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareUpdateNoteEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareUpdateNote",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v35/*: any*/),
                          (v28/*: any*/),
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v5/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareLinkConnection",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": (v36/*: any*/)
          },
          {
            "args": (v14/*: any*/),
            "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseConnection",
            "kind": "LinkedField",
            "name": "focusAreas",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedFocusAreaHasProjectInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v5/*: any*/),
                          (v37/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "userPermissions"
                          },
                          (v6/*: any*/),
                          (v10/*: any*/),
                          {
                            "concreteType": "MercuryFocusAreaStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": (v38/*: any*/)
                          },
                          {
                            "concreteType": "MercuryFocusAreaHealth",
                            "kind": "LinkedField",
                            "name": "health",
                            "plural": false,
                            "selections": (v38/*: any*/)
                          }
                        ],
                        "type": "MercuryFocusArea"
                      },
                      (v39/*: any*/)
                    ]
                  },
                  (v5/*: any*/)
                ]
              },
              (v23/*: any*/)
            ]
          },
          (v40/*: any*/),
          {
            "concreteType": "TownsquareProjectDependencyConnection",
            "kind": "LinkedField",
            "name": "dependencies",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectDependencyEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareProjectDependency",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "linkType"
                      },
                      {
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "incomingProject",
                        "plural": false,
                        "selections": (v11/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareProject",
                        "kind": "LinkedField",
                        "name": "outgoingProject",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v31/*: any*/),
                          (v6/*: any*/),
                          (v10/*: any*/),
                          {
                            "concreteType": "TownsquareIconURIs",
                            "kind": "LinkedField",
                            "name": "iconUrl",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareThemeURIs",
                                "kind": "LinkedField",
                                "name": "square",
                                "plural": false,
                                "selections": [
                                  (v27/*: any*/),
                                  (v26/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v23/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareProjectCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canAddRelatedProjects"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveRelatedProjects"
              },
              {
                "kind": "ScalarField",
                "name": "canAddLinkedGoals"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedGoals"
              },
              (v24/*: any*/),
              (v25/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "goals",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v10/*: any*/),
                      (v6/*: any*/),
                      {
                        "concreteType": "TownsquareStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": (v33/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareGoalType",
                        "kind": "LinkedField",
                        "name": "goalType",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalTypeIcon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                              (v31/*: any*/)
                            ]
                          },
                          (v5/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v23/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareProjectAccessConnection",
            "kind": "LinkedField",
            "name": "access",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectAccessEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "role"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v11/*: any*/),
                        "type": "User",
                        "abstractKey": "__isUser"
                      },
                      (v41/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v11/*: any*/),
                        "type": "AtlassianAccountUser"
                      },
                      (v42/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "isPrivate"
          },
          {
            "kind": "ScalarField",
            "name": "accessLevel"
          },
          {
            "concreteType": "TownsquareUserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": [
              (v22/*: any*/),
              {
                "concreteType": "TownsquareUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v5/*: any*/),
                      (v7/*: any*/),
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "learningsHighlights",
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "LEARNING"
              }
            ],
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": (v43/*: any*/),
            "storageKey": "highlights(type:\"LEARNING\")"
          },
          {
            "alias": "risksHighlights",
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "RISK"
              }
            ],
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": (v43/*: any*/),
            "storageKey": "highlights(type:\"RISK\")"
          },
          {
            "alias": "decisionsHighlights",
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "DECISION"
              }
            ],
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": (v43/*: any*/),
            "storageKey": "highlights(type:\"DECISION\")"
          },
          {
            "concreteType": "TownsquareProjectDescription",
            "kind": "LinkedField",
            "name": "description",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "what"
              },
              {
                "kind": "ScalarField",
                "name": "why"
              },
              {
                "kind": "ScalarField",
                "name": "measurement"
              }
            ]
          },
          (v45/*: any*/),
          {
            "concreteType": "TownsquareProjectUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareProjectUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "ari"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "missedUpdate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "updateType"
                      },
                      (v35/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v5/*: any*/),
                          (v8/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": (v46/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareProjectState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": (v47/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          (v8/*: any*/),
                          (v6/*: any*/),
                          (v5/*: any*/)
                        ]
                      },
                      (v40/*: any*/),
                      (v44/*: any*/),
                      (v10/*: any*/),
                      {
                        "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseConnection",
                        "kind": "LinkedField",
                        "name": "viewers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedProjectUpdateInverseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v18/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v5/*: any*/),
                                      (v6/*: any*/),
                                      (v8/*: any*/),
                                      (v7/*: any*/)
                                    ],
                                    "type": "AtlassianAccountUser"
                                  },
                                  (v41/*: any*/),
                                  (v42/*: any*/)
                                ]
                              },
                              (v5/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "TownsquareProjectState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v47/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v46/*: any*/)
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDateConfidence"
                      },
                      {
                        "concreteType": "TownsquareUpdateNoteConnection",
                        "kind": "LinkedField",
                        "name": "updateNotes",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareUpdateNoteEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareUpdateNote",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v35/*: any*/),
                                  (v28/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "archived"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "TownsquareHighlightConnection",
                        "kind": "LinkedField",
                        "name": "highlights",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareHighlightEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v35/*: any*/),
                                  (v28/*: any*/),
                                  (v18/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isTownsquareHighlight"
                                  },
                                  (v49/*: any*/),
                                  (v50/*: any*/),
                                  (v40/*: any*/),
                                  (v51/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v23/*: any*/)
                        ]
                      },
                      (v45/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareHighlightEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v52/*: any*/),
                        "type": "TownsquareLearning"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v52/*: any*/),
                        "type": "TownsquareRisk"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v52/*: any*/),
                        "type": "TownsquareDecision"
                      }
                    ]
                  }
                ]
              },
              (v23/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareCustomFieldConnection",
            "kind": "LinkedField",
            "name": "customFields",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareCustomFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v37/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v53/*: any*/),
                                "type": "TownsquareTextCustomFieldDefinition"
                              },
                              (v39/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": "textValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v23/*: any*/)
                        ],
                        "type": "TownsquareTextCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v37/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v53/*: any*/),
                                "type": "TownsquareNumberCustomFieldDefinition"
                              },
                              (v39/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": "numberValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v23/*: any*/)
                        ],
                        "type": "TownsquareNumberCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v37/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v53/*: any*/),
                                "type": "TownsquareUserCustomFieldDefinition"
                              },
                              (v39/*: any*/)
                            ]
                          },
                          {
                            "args": (v54/*: any*/),
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v18/*: any*/),
                                      (v5/*: any*/),
                                      (v20/*: any*/),
                                      (v6/*: any*/),
                                      (v7/*: any*/)
                                    ]
                                  },
                                  (v55/*: any*/)
                                ]
                              },
                              (v56/*: any*/),
                              (v23/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v54/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldUser_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          },
                          (v23/*: any*/)
                        ],
                        "type": "TownsquareUserCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v37/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v18/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  (v28/*: any*/),
                                  {
                                    "args": (v54/*: any*/),
                                    "concreteType": "TownsquareCustomFieldTextAllowedValueConnection",
                                    "kind": "LinkedField",
                                    "name": "allowedValues",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareCustomFieldTextAllowedValueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareCustomFieldTextAllowedValueNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v5/*: any*/),
                                              (v32/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "allowedValues(first:100)"
                                  }
                                ],
                                "type": "TownsquareTextSelectCustomFieldDefinition"
                              },
                              (v39/*: any*/)
                            ]
                          },
                          {
                            "args": (v54/*: any*/),
                            "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      {
                                        "alias": "selectValue",
                                        "kind": "ScalarField",
                                        "name": "value"
                                      },
                                      (v18/*: any*/)
                                    ]
                                  },
                                  (v55/*: any*/)
                                ]
                              },
                              (v56/*: any*/),
                              (v23/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v54/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldTextSelect_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          },
                          (v23/*: any*/)
                        ],
                        "type": "TownsquareTextSelectCustomField"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "isProjectNativeIntegrationEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "TownsquareProjectCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  (v57/*: any*/),
                  (v58/*: any*/)
                ]
              },
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 5
                  },
                  (v13/*: any*/)
                ],
                "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemConnection",
                "kind": "LinkedField",
                "name": "linkedJiraWorkItems",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      (v29/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "GraphStoreSimplifiedAtlasProjectTrackedOnJiraWorkItemEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v18/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v5/*: any*/),
                              (v31/*: any*/),
                              (v59/*: any*/),
                              (v35/*: any*/),
                              {
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "permission",
                                    "value": "EDIT_ISSUES"
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "hasProjectPermission",
                                "storageKey": "hasProjectPermission(permission:\"EDIT_ISSUES\")"
                              },
                              {
                                "concreteType": "JiraStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "statusId"
                                  },
                                  (v6/*: any*/),
                                  {
                                    "concreteType": "JiraStatusCategory",
                                    "kind": "LinkedField",
                                    "name": "statusCategory",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "statusCategoryId"
                                      },
                                      (v6/*: any*/),
                                      (v5/*: any*/)
                                    ]
                                  },
                                  (v5/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "issueTypeId"
                                  },
                                  (v6/*: any*/),
                                  (v5/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraIssue"
                          },
                          (v39/*: any*/)
                        ]
                      },
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "isProjectNativeIntegrationEnabled",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": "workTrackingLinks",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  },
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "WORK_TRACKING"
                  }
                ],
                "concreteType": "TownsquareLinkConnection",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": (v36/*: any*/),
                "storageKey": "links(first:1,type:\"WORK_TRACKING\")"
              },
              {
                "concreteType": "TownsquareFusionDetails",
                "kind": "LinkedField",
                "name": "fusion",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "synced"
                  },
                  {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "issue",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v31/*: any*/),
                      (v59/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "TownsquareProjectCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  (v58/*: any*/),
                  (v57/*: any*/)
                ]
              }
            ]
          },
          (v23/*: any*/)
        ]
      },
      {
        "args": (v15/*: any*/),
        "concreteType": "TownsquareProjectAppCapabilities",
        "kind": "LinkedField",
        "name": "projects_capabilities",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "canCreateProject"
          }
        ]
      },
      (v16/*: any*/),
      {
        "concreteType": "MercuryQueryApi",
        "kind": "LinkedField",
        "name": "mercury",
        "plural": false,
        "selections": [
          {
            "args": (v17/*: any*/),
            "concreteType": "MercuryWorkspaceContext",
            "kind": "LinkedField",
            "name": "workspaceContext",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "activationId"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4dccebc1b350e29c4d965ab8e7f8f78d325669b985e4e4f15a4c5f2c3d1e646a",
    "metadata": {},
    "name": "ProjectPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "acaac2c30e01881861ceeb37c2cb458f";

export default node;
